import { render } from "./ImageUsage.vue?vue&type=template&id=3868010a"
import script from "./ImageUsage.vue?vue&type=script&lang=ts"
export * from "./ImageUsage.vue?vue&type=script&lang=ts"
script.render = render

export default script